import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        common: {
            namespaced: true,
            state: {
                banner: {},
                intro: '',
                newsHome: [{}],
                newsTop: {}
            },
            mutations: {
                SET_DATA: (state: any, data: any = {}) => {
                    const { banner, intro, news_home: newsHome, news_top: newsTop } = data;

                    state.banner = banner;
                    state.intro = intro;

                    if (newsHome.length) {
                        state.newsHome = newsHome;
                    }

                    state.newsTop = newsTop;
                }
            },
            actions: {
                setData: ({ commit }, data: any) => {
                    commit('SET_DATA', data);
                }
            }
        }
    }
});
